export enum AdjustmentsColumns {
	id = "Id",
	org = "Org",
	account = "Account",
	counterAccount = "Counter Account",
	customer = "Customer",
	direction = "Direction",
	amount = "Amount",
	status = "Status",
	user = "User",
	description = "Description",
	note = "Note",
	createdAt = "Created At",
	action = "Action",
}

export type AllowedAdjustmentsColumns =
	| AdjustmentsColumns.id
	| AdjustmentsColumns.org
	| AdjustmentsColumns.account
	| AdjustmentsColumns.counterAccount
	| AdjustmentsColumns.customer
	| AdjustmentsColumns.direction
	| AdjustmentsColumns.amount
	| AdjustmentsColumns.status
	| AdjustmentsColumns.user
	| AdjustmentsColumns.description
	| AdjustmentsColumns.note
	| AdjustmentsColumns.createdAt
	| AdjustmentsColumns.action
